import { baseApi, resourceScopeTag, resourceTag } from '@krp/client-runtime'

import { envelope } from '../../../shared/api/envelope'
import { AQSI_TAG_TYPES, AQSI_TAGS } from '../../../shared/api/tags'
import type { AqsiSaleExchangeList } from '../model/types'
import { decodeSaleExchanges, EXCHANGE_KINDS } from './contracts'
import { AQSI_EXCHANGE_URLS } from './urls'

export interface SaleExchangesArgs {
  resourceId: string
  saleId: string
}

/**
 * Журнал обмена продажи с кабинетом в ОБЩЕМ `baseApi` — только чтение своей базы службы: кабинет при этом не вызывается.
 * rid — в аргументах (ключ кэша) и тегах: сброс AQSI-A не перечитывает AQSI-B.
 */
export const exchangeApi = baseApi.enhanceEndpoints({ addTagTypes: AQSI_TAG_TYPES }).injectEndpoints({
  endpoints: (build) => ({
    aqsiSaleExchanges: build.query<AqsiSaleExchangeList, SaleExchangesArgs>({
      query: ({ resourceId, saleId }) => ({
        url: AQSI_EXCHANGE_URLS.sale(resourceId, saleId),
        decode: envelope(EXCHANGE_KINDS.sale, resourceId, (raw) => decodeSaleExchanges(raw, saleId)),
      }),
      providesTags: (_result, _error, { resourceId, saleId }) => [
        resourceTag(AQSI_TAGS.saleExchanges, resourceId, saleId),
        resourceScopeTag(resourceId),
      ],
    }),
  }),
})

export const { aqsiSaleExchanges } = exchangeApi.endpoints
